export enum TipoReporteRefacturacion {
  Manual,
  Despacho,
  Devolucion
}
